"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.dateSelectBodyStyles = function (_a) {
  var x1 = _a.x1;
  return {
    select: {
      display: 'inline-block'
    },
    daySelect: {
      minWidth: 20 * x1
    },
    yearSelect: {
      minWidth: 20 * x1
    }
  };
};